import { render, staticRenderFns } from "./YourOrders.vue?vue&type=template&id=2b8310e7&scoped=true"
import script from "./YourOrders.vue?vue&type=script&lang=js"
export * from "./YourOrders.vue?vue&type=script&lang=js"
import style0 from "./YourOrders.vue?vue&type=style&index=0&id=2b8310e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8310e7",
  null
  
)

export default component.exports